<template>

  <div class="app-container">

    <el-container>
      <!-- <el-aside  width="165px" class="sidebar" :class="{aside_main_show:!asideStatus}"> -->
      <el-aside  class="aside_main" :class="{aside_main_show:!asideStatus}">
        <el-menu @select="handleMenuSelect" :default-active="activeArticleId">
          <el-menu-item v-for="article in articleList" :key="article.ID" :index="article.ID.toString()">
            {{ article.title }}
          </el-menu-item>
        </el-menu>
      </el-aside>

      <el-main class="content">
        <!-- aside侧边栏按钮 -->
        <div class="aside_open_close" @click="asidechange">
          <i class="el-icon-arrow-left" v-if="aside_open_close"></i>
          <i class="el-icon-arrow-right" v-else></i>
        </div>

        <h1 class="title">{{ artInfo.title }}</h1>
        <div class="article-info">
          <div class="meta-info">
            <span class="meta-icon">
              <svg-icon icon-class="create" class="icon" />发表于 {{ artInfo.created_time | dateFormat }}
            </span>
            <span class="meta-icon" v-if="artInfo.updated_time !== ''">
              <svg-icon icon-class="update" class="icon" />更新于
              {{ artInfo.updated_time | dateFormat }}
            </span>
          </div>
        </div>
        <!-- <svg-icon icon-class="calendar" />
            发表于 {{ artInfo.created_time | dateFormat }} •
            <span v-if="artInfo.updated_time !== ''">
              <svg-icon icon-class="calendar" /> 更新于
              {{ artInfo.updated_time | dateFormat }} •</span>
            </div> -->
        <!-- <svg-icon icon-class="category" />
            <span class="classify"><router-link :to="{
              name: 'ArticleList',
              query: { cid: artInfo.cid}
            }">{{ catInfo.name }}</router-link></span>
            •
            <svg-icon icon-class="eye-open" />{{ views }}次围观 -->
        <!-- </div> -->   <!-- codeStyle = "monokai-sublime" --> 
        <!-- codeStyle = "mono-blue"   rainbow purebasic-->
        <div class="article-view">
          <mavon-editor class="markdown" 
          :value="artInfo.content" 
          :subfield="false" 
          defaultOpen="preview"
            :toolbarsFlag="false" 
            :editable="false" 
            :scrollStyle="true" 
            style=" height: 100%; width: 100%"
            :boxShadow="false"
            :ishljs="true"

            codeStyle = "mono-blue"

            preview-background="#fff"
           ></mavon-editor>
        </div>
      </el-main>
    </el-container>

  </div>
</template>

<script>
  import '@/assets/md.css'

  export default {
    props: ['id'],
    data() {
      return {
        asideStatus: true,
        aside_open_close: true,
        selectedArticle: null, // 存储当前选中的文章
        activeArticleId: '', // 存储当前选中的文章的ID，用于高亮显示在左侧边栏
        articleList: [],
        queryParam: {
          title: "",
          pageSize: 100,
          pageNum: 1,
          total: 0,
        },
        artInfo: {
          title: '',
          id: undefined,
          created_time: undefined,
          content: ""

        },
        catInfo: {
          id: 0,
          name: ''
        },
        article: {},
        category: {},
        tags: {},
        views: 0
      };
    },

    mounted() {
    // 获取代码区域的DOM元素，并修改padding
    // const codeArea = this.$refs.editor.$el.querySelector(".mavon-editor__markdown pre");
    // if (codeArea) {
    //   codeArea.style.padding = "5px"; // 调整为适当的值
    // }
  },

    created() {
      this.getArticleList();
      this.getArtInfo(this.id);

    },
    methods: {
      // 侧边栏收缩与展开  参考 https://blog.csdn.net/im_api/article/details/129063203
      asidechange() {
        this.asideStatus = !this.asideStatus

        if (this.asideStatus) {
          setTimeout(() => {
            this.aside_open_close = true
          }, 500)
        } else {
          setTimeout(() => {
            this.aside_open_close = false
          }, 500)
        }
      },
      toggleSidebar() {
        this.isSidebarVisible = !this.isSidebarVisible; // 切换 sidebar 的显示与隐藏
      },
      handleMenuSelect(index) {
        this.activeArticleId = index;
        // this.getArticleContent(index); // 请求文章内容
        this.getArtInfo(this.activeArticleId);
      },

      async getArticleList() {
        const { data: res } = await this.$http.post("getArticleList", {
          title: this.queryParam.title,
          pagesize: this.queryParam.pageSize,
          pagenum: this.queryParam.pageNum
        })
        if (res.status != 200) return this.$message.error(res.message);
        this.articleList = res.data
        this.queryParam.total = res.total
      },
      async getArtInfo(id) {
        const { data: res } = await this.$http.post("getArticle", {
          id: parseInt(id)
        })
        if (res.status != 200) return this.$message.error(res.message);

        this.artInfo = res.data
        this.artInfo.id = res.data.ID
        this.artInfo.title = res.data.title
        this.artInfo.created_time = res.data.CreatedAt
        this.artInfo.updated_time = res.data.UpdatedAt
        this.getCategory()
      },


      async getCategory() {
        const { data: res } = await this.$http.post("getCategory", {
          id: parseInt(this.artInfo.cid)
        })
        if (res.status != 200) return this.$message.error(res.message);

        this.catInfo = res.data
      },
      fetchArticleDetail() {
        // 在这里调用后端接口获取文章详情数据，并将数据赋值给 article
        // 假设后端返回的数据格式包含 title、time、tags、author 和 content 字段
        // 示例数据
        this.article = {
          title: 'Sample Article',
          time: '2023-07-26',
          tags: ['Technology', 'Web Development'],
          author: 'John Doe',
          content: '<p>This is the sample article content. It may contain HTML markup.</p>',
        };
      },
    },
  };
</script>

<style>
  .mavonEditor {
  width: 100%;
  height: 100%;
}
  svg {
    margin: 0 5px;
  }

  .app-container {
    display: flex;
    height: 100%;
    overflow-y: hidden;
    /* Hide horizontal scrollbar */
    /* margin: 0; */
  }



  .el-aside {
    width: 5px;

  }


  .sidebar {

    /* min-height: 100%; */
    /* height: calc(100vh - 70px); */
    /* background-color: #87ceeb; */
    /* 左侧边栏占据12%的宽度 */
    /* padding: 5px; */
    border-right: 1px solid #6fa6d3;
    bottom: 0;
    margin: 0px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    /* height: 10%; */
    /* 垂直排列 */
    /* height: 100%; */
    /* height:calc(100vh - 70px); */
    /* position: sticky; */

    /* 让左侧边栏固定 */
    /* position: relative;  */
  }


  .sidebar-item {
    cursor: pointer;
    margin-bottom: 10px;
  }


  .title {
    text-align: center;

  }

  .content {
    flex: 1;
    /* 右侧内容占据剩余宽度 */
    /* padding: 20px; */
    line-height: 1.6;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;

  }

  .article-info {
    margin-top: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    text-align: center;
  }

  .meta-info {
    display: flex;
    /* Use flexbox to align the icon and text */
    align-items: center;
    /* Align items vertically at the center */
    margin-top: 10px;
    /* Optional: Add some space between article content and meta-info */
  }

  .icon {
    /* Styles for the icon */
    width: 16px;
    /* Adjust the width as needed */
    height: 16px;
    /* Adjust the height as needed */
    margin-right: 5px;
    /* Optional: Add some space between icon and text */
  }

  .meta-icon {
    margin-right: 15px;
  }

  /* 侧边栏样式 */
  .aside_main {
    width: 165px !important;
    transition: width 0.5s;
    border-right: 1px solid #6fa6d3;
    bottom: 0;
    margin: 0px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .aside_main_show {
    width: 0px !important;
  }


  /* 侧边栏按钮样式 */
  .aside_open_close {
    position: absolute;
    left: 0;
    top: 50%;
    width: 16px;
    height: 60px;
    line-height: 60px;
    color: #fff;
    background-color: #2A333A;
    border-radius: 0 6px 6px 0;
    font-size: 20px;
    z-index: 1000;
    cursor: pointer;
  }

  .aside_open_close:hover {
    background-color: #FF8E2B;
    color: #fff;
  }


  .markdown-body .highlight pre, .markdown-body pre {
  padding: 0px !important; /* 调整为适当的值 */
  font-size: 14px !important; 
}

.markdown-body pre code {
  /* padding: 10px !important;  */
  display: block !important;
  margin: 8px !important; 
  padding-left: 10px !important;
  font-size: 14px !important; 
}

/* code {
  padding: 10px !important;
  margin: 10px !important; 
} */

</style>